import { onClickOutside } from '../utils/on-click-outside';
import { isDesktop } from '../constants/breakpoints';
import form from '../utils/form';

let modalIsOpen = false;
let eventHandler: (e: MouseEvent) => void;
let modalEl: HTMLElement;
let modalClose: HTMLButtonElement;

document.addEventListener('DOMContentLoaded', function() {
  modalEl = document.querySelector('.m-modal--bottom') as HTMLElement;
  modalClose = modalEl.querySelector('.m-modal__close') as HTMLButtonElement;

  modalClose.addEventListener('click', hideModal);

  // Show modal if newsletter form has been submitted (not when it was the footer's sign-up,
  // which shows its own thank-you: modules/footer.ts)
  if (window.location.hash === '#contact_form' && !sentFromFooter()) showModal();

  const formEl = modalEl?.querySelector('.m-customer__form') as HTMLFormElement;
  const formErrors = modalEl?.querySelector('.m-customer__errors') as HTMLElement;

  if (formEl && formErrors) {
    // form.handleSubmit(formEl, formErrors, () => console.log('sent'));
  }
});

// the footer's sign-up (modules/footer.ts) leaves a note for the page it reloads into; read
// it once and clear it (footer.ts reads it first, before the page has finished loading)
const sentFromFooter = () => {
  try {
    const yes = sessionStorage.getItem('paracia:newsletter-from-footer') === '1';
    sessionStorage.removeItem('paracia:newsletter-from-footer');
    return yes;
  } catch {
    return false;
  }
};

// Helpers
const scrollToBotton = (event: TransitionEvent) => {
  if (event.propertyName === 'grid-template-rows') {
    modalEl.removeEventListener('transitionend', scrollToBotton);
    window.scrollTo(0, document.body.scrollHeight);
  }
};

const showModal = () => {
  // The panel holds the newsletter and, on product pages, the back-in-stock sign-up
  // (components/back-in-stock.ts). It always opens on the newsletter — that component
  // switches to its own form afterwards. This happens before the check below, so
  // Newsletter brings the newsletter back even while the sign-up is showing.
  const newsletter = modalEl?.querySelector('.m-newsletter') as HTMLElement | null;
  const stock = modalEl?.querySelector('.m-stock') as HTMLElement | null;

  if (newsletter) newsletter.hidden = false;
  if (stock) stock.hidden = true;

  if (modalIsOpen) return;

  // Scroll to the bottom of the page on desktop
  if (isDesktop()) {
    modalEl.addEventListener('transitionend', scrollToBotton);
  }

  document.removeEventListener('click', eventHandler);
  document.body.classList.add('modal-bottom-is-open');
  modalIsOpen = true;

  eventHandler = onClickOutside(modalEl, hideModal);
}

const hideModal = () => {
  document.body.classList.remove('modal-bottom-is-open');
  document.removeEventListener('click', eventHandler);
  modalIsOpen = false;
}

export const modal = {
  showModal,
  hideModal
};

export default modal;